<template>
    <BasePanel
        headline='lang_GENERIC_CAPTION_OTHER_IDS'
        :alvqa="alvqa"
    >
    <template v-slot:panelContent>
        <v-data-table
            :headers="headers"
            :items="items"
            hide-default-footer
            :header-props="{ sortIcon: '' }"
            :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            class="noMinWidth"
            :items-per-page="itemsPerPage"
        >   
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.name`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="$alvPlugin.getOtherIdsRoleLabel(item)"
                            :alvqa="alvqa +'-list-row-' + index + '-text-name'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="getTypeText(item.type)"
                            :alvqa="alvqa +'-list-row-' + index + '-text-type'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.source`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.source !== null ? item.source : 'ALV'"
                            :alvqa="alvqa +'-list-row-' + index + '-text-source'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.value`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.value"
                            :alvqa="alvqa +'-list-row-' + index + '-text-value'"
                        />
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>
  
<script>
import BasePanel from "@/components/_base/BasePanel";
import BaseTooltip from "@/components/_base/BaseTooltip";
import {
    DropdownAzPersonsOtherIdsTypes
} from "@/assets/dropdowns/alvDropdowns.js";

export default {
    name: "OtherIdsReadOnlyPanel",
    components: {
        BasePanel,
        BaseTooltip,
    },
    props: {
        azGroupsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: `az-groups-list-row-${this.azGroupsAlvId}-read-only-panel-other-ids`,
            context: "AzGroupsOtherIds",
        };
    },
    computed: {
        items() {
            return this.$store.getters.getAzGroupsOtherIds;
        },
        itemsPerPage() {
            return this.$store.getters.getItemsPerPage;
        },
        headers() { 
            return [
                {
                    text: this.$t("lang_AZ_PERSONS_CAPTION_TYPE"),
                    value: "type",
                    alvqa: this.alvqa + "-header-type",
                    width: "160px"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_SOURCE"),
                    value: "source",
                    alvqa: this.alvqa + "-header-source",
                    width: "90px"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_ID"),
                    value: "value",
                    alvqa: this.alvqa + "-header-id",
                    width: "170px"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_REMARK"),
                    value: "name",
                    alvqa: this.alvqa + "-header-name",
                },
            ]
        },
    },
    methods: {
        getTypeText(type) {
            let options = DropdownAzPersonsOtherIdsTypes;
            let result = options.find((el) => el.value == type)

            return result ? this.$t(result.text) : ""
        },
    }
  };
  </script>
  
  <style>
  .noMinWidth table {
    min-width: 0px !important;
    table-layout: fixed;
  }
  </style>
